module.exports = __webpack_public_path__ + "img/37.961b0690.jpg";